module.exports = __webpack_public_path__ + "img/simplex-icon.f5b6fde.png";